"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3H2v18h20V3zM9.069 15.0296v1.26h5.9879v-1.524h-3.732v-.084l1.104-1.032c.504-.464.932-.888 1.284-1.272.36-.384.632-.772.816-1.164.192-.392.288-.824.288-1.296 0-.44-.112-.832-.336-1.176-.216-.352-.528-.628-.936-.828-.4-.208-.88-.312-1.44-.312-.512 0-.952.06-1.32.18-.36.112-.68.26-.96.444-.28.184-.54.384-.78.6l.984 1.164c.344-.28.672-.496.984-.648.312-.152.632-.228.96-.228.32 0 .572.084.756.252.192.168.288.424.288.768 0 .28-.06.544-.18.792-.12.24-.312.512-.576.816-.264.296-.612.668-1.044 1.116l-2.148 2.172z"
  })];
};

exports.default = _default;